export interface IApp {
  application?: string;
  clientId?: string;
  edition?: string;
  language: string;
  languageCode: string;
  env?: string | number;
  appVersion?: string;
  appName?: string;
  assetLevel?: number;
  projectLevel?: number;
  userType?: string;
  share?: boolean;
}

export interface IApiHeader {
  token: string;
  language: string;
}

export enum GlobalErrorType {
  NONE = 0,
  UNKNOWN = 1,
  NET_WORK = 2,
}

export interface IAppStore {
  appState: IApp;
  isInitLoading: boolean;
  onInitApp: (query: string) => void;
  apiHeaderState: IApiHeader;
  onUpdateToken: () => void;
  onInitLanguage: () => void;
  appErrorState: GlobalErrorType;
  onErrorUnknown: () => void;
}
